import React, { useState } from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import SwitchWithLabel from '../SwitchWithLabel';
import ShadowBox from '../ShadowBox';
import { CommonProperties } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
const NotificationModal = () => {
  const { tKey } = useComponentTKey('NotificationModal');
  const { t } = useTranslation(i18nNS.settings);
  const [eventUpdates, setEventUpdates] = useState(false);
  const [tripStatus, setTripStatus] = useState(false);
  const [savingAlert, setSavingAlert] = useState(false);
  const [friendMessage, setFriendMessage] = useState(false);

  return (
    <ScrollView>
      <ShadowBox style={styles.shadowBox}>
        <SwitchWithLabel
          value={eventUpdates}
          onChange={() => {
            setEventUpdates(!eventUpdates);
          }}
          label={t(tKey('PushEvent'))}
        />
        <SwitchWithLabel
          value={tripStatus}
          onChange={() => {
            setTripStatus(!tripStatus);
          }}
          label={t(tKey('PushTrip'))}
        />
        <SwitchWithLabel
          value={friendMessage}
          onChange={() => {
            setFriendMessage(!friendMessage);
          }}
          label={t(tKey('PushFriend'))}
        />
        <SwitchWithLabel
          value={savingAlert}
          onChange={() => {
            setSavingAlert(!savingAlert);
          }}
          label={t(tKey('PushAlert'))}
        />
      </ShadowBox>
    </ScrollView>
  );
};
const styles = StyleSheet.create({
  shadowBox: {
    ...CommonProperties.my3,
    ...CommonProperties.p3,
  },
});

export default NotificationModal;
